import { Edit, SlidersHorizontal } from 'lucide-react';
import { Button, Eyebrow } from '@/shared/components';
import { FullSyncButton } from '../ari-edit';

interface Props {
  published: boolean;
  currency: string;
  propertyId: string;
  canEdit: boolean;
  canFull: boolean;
  onOpenBatch: () => void;
  onOpenEditor: () => void;
}

/** Kopf des Preise-Reiters mit den drei Übertragungswegen an den Kanalmanager. */
export function PreiseTabHeader({
  published,
  currency,
  propertyId,
  canEdit,
  canFull,
  onOpenBatch,
  onOpenEditor,
}: Props) {
  return (
    <header className="mb-6 flex flex-wrap items-end justify-between gap-4">
      <div className="min-w-0">
        <Eyebrow>Preise &amp; Belegung</Eyebrow>
        <h2 className="text-ink mt-3 font-serif text-3xl font-normal tracking-tight">
          Raten &amp; <span className="font-serif-italic">Verfügbarkeit</span>
          <span className="text-sealwax">.</span>
        </h2>
        <p className="text-ink-soft mt-2 max-w-prose text-sm">
          Tagespreise, Mindestaufenthalt und Verkaufsstopp für einzelne Zeiträume — von hier gehen
          sie an den Kanalmanager.
        </p>
      </div>
      {published && (canEdit || canFull) && (
        <div className="flex flex-wrap items-center gap-2">
          {canFull && <FullSyncButton propertyId={propertyId} currency={currency} />}
          {canEdit && (
            <>
              <Button
                variant="ghost"
                size="sm"
                leftIcon={<SlidersHorizontal size={13} strokeWidth={2} aria-hidden />}
                onClick={onOpenBatch}
              >
                Mehrere Zeiträume
              </Button>
              <Button
                variant="brand"
                size="sm"
                leftIcon={<Edit size={13} strokeWidth={2} aria-hidden />}
                onClick={onOpenEditor}
              >
                Preise bearbeiten
              </Button>
            </>
          )}
        </div>
      )}
    </header>
  );
}
